import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryProvider } from './components/shared/query-provider';
import App from './app';
import reportWebVitals from './reportWebVitals';
import './services/firebase';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <>
        <QueryProvider>
            <App />
        </QueryProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
